import useFetch from './fetch';

export default function useGetCategories() {
    const fetch = useFetch();
    return () => { return fetch(`/api/categories`).then(x => x.json()) };
};
